export default "__VITE_ASSET__BlbmF6tZ__"